import { placeholder } from "@babel/types";
import { useField } from "formik";
import React, { useState } from "react";
import Select from "react-select";
import { ValueType } from "react-select/src/types";

export type MultiSelectOption = { value: any; label: string };

type MultiDropdownProps = {
  options: { value: any; label: string }[];
  value: ValueType<MultiSelectOption, any>;
  onChange(selectedOption: ValueType<MultiSelectOption, any>): void;
  roundedRectangle?: boolean;
  small?: boolean;
  placeholder?: string;
  defaultMenuIsOpen?: boolean;
  customClassName?: string;
  customNoOptionsMessage?: string;
  isSearchable?: boolean;
  onClear?: () => void;
  styles?: any;
  isClearable?: boolean;
  portalMode?: boolean;
};

type Props = MultiDropdownProps;

const MultiDropdown: React.FC<Props> = ({
  options,
  value,
  onChange,
  placeholder,
  roundedRectangle,
  small,
  defaultMenuIsOpen,
  customClassName,
  customNoOptionsMessage,
  isSearchable,
  onClear,
  styles,
  isClearable,
  portalMode,
}) => {
  let finalIsSearchable = true;

  if (isSearchable === false) {
    finalIsSearchable = false;
  }
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [touched, setTouched] = useState<boolean>(false);

  return (
    <Select
      isMulti
      isSearchable={finalIsSearchable}
      placeholder={placeholder}
      className={`${
        roundedRectangle
          ? small
            ? "CustomSelect RoundedRect Small"
            : "CustomSelect RoundedRect"
          : small
          ? "CustomSelect Small"
          : "CustomSelect"
      } ${customClassName ? customClassName : ""} ${touched ? "Touched" : ""}`}
      defaultMenuIsOpen={defaultMenuIsOpen}
      classNamePrefix="CustomSelect"
      options={options}
      value={value}
      menuIsOpen={menuOpen}
      onMenuOpen={() => {
        setMenuOpen(true); // NOTE: This is needed to make click on mobile phones work
      }}
      onMenuClose={() => {
        setMenuOpen(false); // NOTE: This is needed to make click on mobile phones work
      }}
      onChange={
        onClear
          ? (value, { action }) => {
              if (
                action === "clear" ||
                (action === "remove-value" &&
                  ((Array.isArray(value) && value.length === 0) ||
                    value === null))
              ) {
                console.log("clear action: ");
                onClear();
              } else {
                console.log("on change action: ", action);
                onChange(value);
              }
            }
          : onChange
      }
      menuPlacement="auto"
      noOptionsMessage={
        customNoOptionsMessage ? () => customNoOptionsMessage : undefined
      }
      styles={
        portalMode
          ? {
              menuPortal: base => ({ ...base, zIndex: 9999 }),
              option: (base, { isSelected, isDisabled, isFocused }) => ({
                backgroundColor: isSelected
                  ? "#ff5a00"
                  : isFocused
                  ? "#ffe6d9"
                  : "#f5f5f5",
                color: isSelected ? "#4C9AFF" : "#58595b",
                fontSize: "12px",
                padding: "10px",
                cursor: isDisabled ? "not-allowed" : "pointer",
              }),
              menuList: base => ({
                ...base,
                backgroundColor: "#f5f5f5",
                borderRadius: "3px",
                margin: "5px 0",
              }),
              menu: base => ({
                ...base,
                backgroundColor: "#f5f5f5",
              }),
              ...styles,
            }
          : styles
          ? styles
          : undefined
      }
      menuPortalTarget={portalMode ? document.body : undefined}
      isClearable={isClearable ?? undefined}
      onFocus={() => setTouched(true)}
    />
  );
};

export { MultiDropdown };
